import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=7165f153&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=ts"
export * from "./Permission.vue?vue&type=script&lang=ts"
import style0 from "./Permission.vue?vue&type=style&index=0&id=7165f153&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7165f153",
  null
  
)

export default component.exports